<template>
  <div>
    <common-dialog ref="dialog" width="1100px" :show-save-button="$permission.canEdit()" unit="商品调价模板" edit-title id-key="RecordId" :data="data" :form-rules="rules"
      @edit-opened="onEditOpened" :save-func="api.save" close-on-saved :before-save="onBeforeSave" @closed="onClosed">
      <template slot="form">
        <el-row>
          <el-col :span="8">
            <el-form-item label="模板名称" prop="AdjustName" label-width="85px">
              <el-input v-model="data.AdjustName" placeholder="请输入模板名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="价格生效时间" prop="EffectTime" label-width="110px">
              <el-date-picker type="datetime" v-model.trim="data.EffectTime" placeholder="请选择日期"
                value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="状态" prop="State">
              <el-radio-group v-model="data.State">
                <el-radio :label="1">正常</el-radio>
                <el-radio :label="0">停用</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-table border :data="data.PriceDetails" highlight-current-row>
          <el-table-column prop="TypeName" label="商品分类" min-width="70px" />
          <el-table-column prop="GoodsName" label="商品名称" min-width="140px" />
          <el-table-column prop="GoodsCode" label="商品编码" min-width="140px" />
          <el-table-column prop="AttributeName" label="规格型号" min-width="140px" />                 
          <el-table-column prop="MainUnitName" label="单位" min-width="60px" />         
          <el-table-column prop="OriginalPrice" label="原价" min-width="120px">
            <template slot-scope="{ row }">
              <el-input v-model="row.OriginalPrice" @input="onInput(row)" placeholder="输入原价"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="PlatformPrice" label="销售价" min-width="120px">
            <template slot-scope="{ row }">
              <el-input v-model="row.PlatformPrice" @input="onInput(row)" placeholder="输入销售价"></el-input>
            </template>
          </el-table-column>
          <el-table-column align="center" width="60px" fixed="right">
            <template slot="header">
              <i class="el-icon-circle-plus-outline add-icon" @click="addGoodsAttribute"></i>
            </template>
            <template slot-scope="{ row, $index }">
              <el-button icon="el-icon-delete" type="text" @click="delGoodsAttribute(row, $index)"></el-button>
            </template>
          </el-table-column>
        </el-table>
      </template>
      <template #footer v-if="!$permission.canEdit()">
           <el-button @click="close">关 闭</el-button>
      </template>
    </common-dialog>
    <attribute-dialog ref="attributeDialog" selectable multiple in-dialog @select-multiple="setGoodsAttribute" />
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import attributeDialog from "@/components/goods/goodsattribute/listDialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    attributeDialog
  },
  data() {
    return {
      data: {
        RecordId: 0,
        AdjustName: "",
        EffectTime: null,
        State: 1,
        PriceDetails: [],
      },
      DelPriceDetails: [],
      api: require("@/api/goods/adjustprice").default,
      rules: {
        AdjustName: [{ required: true, message: "模板名称不能为空" }],
        EffectTime: [{ required: true, message: "价格生效时间不能为空" }],
      },
    };
  },
  methods: {
    onEditOpened(data) {
      this.api.getPriceDetails(data.RecordId).then(res => {
        if (res.Data) {
          this.data.PriceDetails = res.Data.map(x => ({ ...x, T: null }));
          console.log("data", this.data)
        }
      })
    },
    onInput(row) {
      if (row.T !== 0) row.T = 1;
    },
    onBeforeSave() {
      console.log("save", JSON.parse(JSON.stringify(this.data.PriceDetails)));

      if (this.data.PriceDetails.length == 0) {
        this.$message.warning("请添加商品");
        return false;
      }

   

      if (this.data.PriceDetails.some(x => !x.OriginalPrice)) {
        this.$message.warning("原价不能为空");
        return false;
      }

      if (this.data.PriceDetails.some(x => !x.PlatformPrice)) {
        this.$message.warning("销售价不能为空");
        return false;
      }

      var data = this.$commonJs.obj.removeNullKey(this.data);
      data.PriceDetails = this.data.PriceDetails.filter(x => x.T != null);
      this.DelPriceDetails.forEach(x => data.PriceDetails.push(x));

      console.log("save", data);

      // return false;
      this.loading();
      this.api.save(data).then(res => {
        this.loading(false);
        if (res.Code == 0) {
          this.$message.success(res.Msg);
          this.close(true);
          this.$emit('close-saved');
        } else {
          this.$message.error(res.Msg);
        }
      })

      return false;
    },
    addGoodsAttribute() {
      let ids = this.data.PriceDetails.map((x) => x.AttributeId);
      this.$refs.attributeDialog.open().then((that) => {
        that.getTree();
        that.getData({ Status: 1, NotIds: ids });
      });
    },
    setGoodsAttribute(data) {
      console.log("setGoodsAttribute", JSON.parse(JSON.stringify(data)));
      data.forEach((x) => {
        this.data.PriceDetails.push({
          RecordId: 0,
          AdjustId: this.data.RecordId,
          OrderId: 0,
          GoodsId: x.GoodsId,
          GoodsCode: x.GoodsCode,
          GoodsName: x.GoodsName,
          TypeId: x.TypeId,
          TypeName: x.TypeName,
          MainUnitid: x.MainUnitid,
          MainUnitName: x.MainUnitName,
          AuxiliaryUnitid: x.AuxiliaryUnitid,
          AuxiliaryUnitName: x.AuxiliaryUnitName,
          AttributeId: x.RecordId,
          OriginalPrice: null,
          PlatformPrice: null,
          AttributeName:x.AttributeName,
          T: 0,
        });
      });
    },
    delGoodsAttribute(row, index) {
      this.$confirm("确认删除该行数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        if (row.T !== 0) {
          this.DelPriceDetails.push({ ...row, T: 2 });
        }
        this.data.PriceDetails.splice(index, 1);
      });
    },
    onClosed() {
      this.data.PriceDetails = [];
      this.DelPriceDetails = [];
    },
  },
};
</script>